import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import AdminShell from '../components/admin/AdminShell';
import AdminManageWalletView from '../components/views/admin/AdminManageWalletView';
import { SkeletonAdminBody } from '../components/Skeleton';

function AdminManageWalletPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }

        const res = await api.get('/auth/me');
        const raw = res?.data;
        const userData = raw && raw.user ? raw.user : raw;

        if (!userData || !userData._id) {
          navigate('/login');
          return;
        }

        if (userData.role !== 'A') {
          navigate('/dashboard');
          return;
        }

        if (userData.locked) {
          navigate('/locked');
          return;
        }

        setUser(userData);
      } catch (error) {
        console.error('Error fetching user:', error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-green-50">
        <SkeletonAdminBody form />
      </div>
    );
  }

  if (!user) return null;

  return (
    <AdminShell user={user} title="Manage Wallet" subtitle="Wallet">
      <AdminManageWalletView user={user} />
    </AdminShell>
  );
}

export default AdminManageWalletPage;

